import React from 'react';
import { useLocation, useParams, useNavigate, useNavigationType } from 'react-router-dom';

const withRouter = (WrappedComponent) => {
  return (props) => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const navigationType = useNavigationType(); // use for history.listen

     // Mimic `history` object by adding push and replace methods
    const history = {
        push: (path, state) => {
            setTimeout(() => navigate(path, { state }), 0);
        },
        replace: (path, state) => {
            setTimeout(() => navigate(path, { replace: true, state }), 0)
        },
        goBack: () => navigate(-1),  // Equivalent to history.goBack()
    };

    return (
      <WrappedComponent
        {...props}
        location={location}
        navigationType={navigationType}
        params={params}
        history={history}
      />
    );
  };
};

export default withRouter;